import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=057075ba&scoped=true"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=057075ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057075ba",
  null
  
)

export default component.exports